// * Bootstrap libraries
import './_bootstrap';

// * Any other global site-wide JavaScript should be placed below.
(function (Drupal) {
  Drupal.behaviors.syncViewContentHeight = {
    attach(context) {
      once('sync-view-content-height', 'body', context).forEach(() => {

        // Get viewport width and height
        const viewportWidth = window.innerWidth;
        if (viewportWidth < 1202) {
          // For mobile, we don't need to sync heights
          return;
        }

        // Do the same on resize to handle dynamic changes in viewport size
        window.addEventListener('resize', () => {
          const newViewportWidth = window.innerWidth;
          if (newViewportWidth < 1202) {
            // For mobile, we don't need to sync heights
            return;
          }
        });


        // const newsList = document.querySelector('.view-eikonidia-arhikis-selidas .view-content');
        // const carousel = document.querySelector('.carousel-slider .view-content');
        // console.log('News List:', newsList);
        // console.log('Carousel:', carousel);
        // if (!newsList || !carousel) return;

        // newsList.style.height = `${carousel.offsetHeight}px`;
      });
    },
  };
}(Drupal));
